import ApiConfig from "../../../config/api-config";
import { $apiClientForm } from "../../../utils/apiClient";

export function postDeleteGodo(payload) {
  return $apiClientForm.delete(`${ApiConfig.DELETE}` + payload);
}
